// Types
import { IIndexable } from "types/common";

import { TestNetConfig, NetworkInfo as _tn_info } from "./testnetConfig";
import { MainNetConfig, NetworkInfo as _mn_info } from "./mainnet";
import { PolygonMainNetConfig } from "./polygon-mainnet";
import { PolygonTestNetConfig } from "./polygon-testnetConfig";

export const rpcUrlMapping: IIndexable = {
  1: process.env.NEXT_PUBLIC_ALCHEMY_HTTPS_URL,
  137: process.env.NEXT_PUBLIC_ALCHEMY_POLYGON_HTTPS_URL,
};

export const ethConfig =
  process.env.NEXT_PUBLIC_NETWORK == "mainnet" ? MainNetConfig : TestNetConfig;

export const polygonConfig =
  process.env.NEXT_PUBLIC_NETWORK == "mainnet"
    ? PolygonMainNetConfig
    : PolygonTestNetConfig;

export const currentNetworkInfo =
  process.env.NEXT_PUBLIC_NETWORK == "mainnet" ? _mn_info : _tn_info;
